<!-- 首页 -->
<template>
  <div id="dashboard" ref="dashboard">
    <div class="top">
      <div class="top-img-box clearfix">
        <div class="left">
          <img :src="imgTop" alt="" class="img imgTop">
        </div>
        <div class="left line" />
        <div class="left title">
          {{ $t('main.campus-pay-cost') }}
        </div>
        <!--<div class="right language">-->
        <!--EngLish-->
        <!--</div>-->
      </div>
      <!-- 8个功能 -->
      <div class="second">
        <div class="flex">
          <div
            v-for="item in recommendedProjectList"
            :key="item.index"
            class="imgBox"
            @click="goToPay(item)"
          >
            <img :src="item.imgUrl" alt="" class="img img-size">
            <p class="text wrapText">{{ item.projectName }}</p>
          </div>
          <div
            class="imgBox"
            @click="toMore"
          >
            <img :src="iconList[0].imgUrl" alt="" class="img img-size">
            <p class="text wrapText">{{ $t('main.more') }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 特色服务 -->
    <div class="third">
      <p class="title-text">{{ $t('home.characteristic') }}</p>
      <div class="feature clearfix">
        <div class="item-feature clearfix left">
          <img :src="featureIconList[0]" alt="" class="img feature-img left">
          <div class="left feature-text flex-c">
            <p class="text-first" @click="searchClick">{{ $t('home.search-pay') }}</p>
            <p v-if="needHide" class="text-second">{{ $t('home.search-des') }}</p>
          </div>
        </div>
        <div class="item-feature clearfix right">
          <img :src="featureIconList[1]" alt="" class="img feature-img left">
          <div class="left feature-text flex-c" @click="doMethod('leaveSchoolPayWay')">
            <p class="text-first">{{ $t('home.school-leave') }}</p>
            <p v-if="needHide" class="text-second">{{ $t('home.leave-title') }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 轮播图 -->
    <div class="swipe">
      <van-swipe
        :autoplay="3000"
        indicator-color="white"
      >
        <van-swipe-item v-for="(image, index) in swipeList" :key="index">
          <img :src="image" class="img swipe-img">
        </van-swipe-item>
        <template #indicator>
          <div />
        </template>
      </van-swipe>
    </div>
    <!-- 消息中心 -->
    <div class="message-center">
      <p class="title-text">{{ $t('home.news') }}</p>
      <ul class="message-box">
        <li v-if="stuNotice.content" class="message-item clearfix" @click="mesClick">
          <div class="left">
            <img :src="messageImg" alt="" class="img message-img">
          </div>
          <div class="left middle">
            <div class="text-first wrapText" v-html="stuNotice.content" />
            <p class="text-second message-date">{{ stuNotice.updateDate }}</p>
          </div>
          <div class="arrowImg-box">
            <img :src="arrowImg" alt="" class="img arrowImg">
          </div>
        </li>
      </ul>
    </div>
    <van-popup v-model="mesDialogShow" class="mesPopup" position="top">
      <div class="message-box">
        <span class="notice">{{ $t('home.news') }}</span>
        <div class="html-p content" v-html="stuNotice.content" />
        <p class="html-p date">{{ stuNotice.updateDate }}</p>
      </div>
    </van-popup>
    <!-- 底部菜单栏 开始 -->
    <ReiTabbar />
    <!-- 底部菜单栏 结束 -->
  </div>
</template>

<script>
import { Toast } from 'vant'
import { getRecommendedProjectList, getProjectIsAllowPayment } from '@/api/project'
import { getStuNotice } from '@/api/notice'
import Vue from 'vue'
import ReiTabbar from './components/ReiTabbar.vue'
import preventBack from 'vue-prevent-browser-back' // 组件内单独引入
import {
  Swipe,
  SwipeItem,
  Button,
  Image,
  Grid,
  GridItem,
  Card,
  Divider,
  Row,
  Col
} from 'vant'

Vue.use(Grid).use(GridItem)
Vue.use(Button)
Vue.use(Image)
Vue.use(Swipe).use(SwipeItem)
Vue.use(Card)
Vue.use(Divider)
Vue.use(Row).use(Col)

export default {
  name: 'Index',
  components: {
    ReiTabbar
  },
  mixins: [preventBack], // 注入
  data() {
    return {
      needHide: '', // 隐藏p字段,为true显示,为false隐藏
      // 消息中心弹出
      mesDialogShow: false,
      mesObj: {},
      // top图
      imgTop: require('../assets/newImages/logo.png'),
      // message
      messageImg: require('../assets/newImages/home_message.png'),
      // 箭头
      arrowImg: require('../assets/newImages/home_arrow.png'),
      // 8个功能图标数组
      recommendedProjectList: [],
      iconList: [{
        imgUrl: require('../assets/newImages/icon8.png'),
        name: '更多',
        path: 'moreMpplications'
      }],
      // 特色服务图
      featureIconList: [
        require('../assets/newImages/feature1.png'),
        require('../assets/newImages/feature2.png')
      ],
      // 轮播图
      swipeList: [
        require('../assets/newImages/swipe.png')
      ],
      // 消息中心
      stuNotice: []
    }
  },
  beforeMount() {
    document.querySelector('body').setAttribute('style', 'background: #FFFFFF')
  },
  mounted() {
    this.getStuNotice()
    this.getRecommendedProjectList()
    window.addEventListener('scroll', this.scrollToTop)
    this.top()
    this.hidPart()
    // 监听resize方法
    // window.addEventListener("resize", this.renderResize, false);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    hidPart() {
      if (window.localStorage.getItem('language') === 'cn') {
        this.needHide = true
      } else {
        this.needHide = false
      }
    },
    searchClick() {
      this.$router.push({ path: 'searchPay' })
    },
    mesClick(item) {
      this.mesDialogShow = true
    },
    // 跳转项目缴费页面
    goToPay(item) {
      getProjectIsAllowPayment(item.id).then(response => {
        this.messageCode = response.messageCode
        if (this.messageCode !== '0') {
          Toast.fail({
            message: response.data,
            type: 'error'
          })
          return false
        } else {
          // 根据不同Mode要进不同页面走不同接口
          this.$router.push({ path: item.proModelUrl + 'Pay', query: { projectId: item.id }})
        }
      }).catch(err => {
        Toast.fail(err.message)
      })
    },
    // 去更多
    toMore() {
      this.$router.push({ path: 'moreMpplications' })
    },
    // 查询推荐服务 7图标+更多
    getRecommendedProjectList() {
      getRecommendedProjectList(this.$store.state.settings.schoolCode).then(response => {
        // console.log('all')
        // console.log(response.data)
        this.recommendedProjectList = response.data
      }).catch(err => {
        Toast.fail(err.message)
      })
    },
    // 消息中心
    getStuNotice() {
      getStuNotice(this.$store.state.settings.schoolCode, this.$store.state.settings.dataSource).then(response => {
        if (response.data) {
          this.stuNotice = response.data
        }
      }).catch(err => {
        Toast.fail(err.message)
      })
    },
    doMethod(vueName) {
      this.$router.push({ path: vueName })
    },
    // 初始回顶部
    top() {
      // var scrolltop = document.documentElement.scrollTop || document.body.scrollTop
      document.documentElement.scrollTop = document.body.scrollTop = 0
      //  scroll('0px', 300);
    }
  }

}
</script>
<style lang="scss" scoped>
    .notice {
        font-size: 20px;
        font-weight: bold;
        line-height: 40px;
    }

    .mesPopup {
        border-radius: 0 0 20px 20px;
        padding: 20px;

        .content {
            line-height: 30px;
        }

        .date {
            text-align: right;
            color: #CCCCCC;
            font-size: 16px;
        }
    }

    .html-p {
        font-size: 18px;
    }

    .wrapText {
        line-height: 30px;
        width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        color: #2E2E2E;
        height: 14px;
        font-size: 14px;
    }

    .dashbord {
        position: relative;
    }

    .my-swipe .van-swipe-item {
        color: #fff;
        font-size: 20px;
        line-height: 150px;
        text-align: center;
        background-color: #39a9ed;
    }

    // #login{
    //   // border-top:1px solid rgba(55,147,229,1);
    //   // background:linear-gradient(135deg,rgba(55,147,229,1) 0%,rgba(61,105,199,1) 100%);
    // }
    .top {
        padding: 0 14px;
        background: linear-gradient(135deg, rgba(55, 147, 229, 1) 0%, rgba(61, 105, 199, 1) 100%);
        height: 140px;
        padding-top: 30px;
        position: relative;

        .top-img-box {
            height: 33px;
            position: relative;

            .imgTop {
                width: 97px;
                height: 33px;
                // background: white;
                // color: white;
            }

            .title {
                height: 33px;
                margin-left: 24px;
                line-height: 33px;
                font-size: 14px;
                font-family: STHeitiSC-Medium, STHeitiSC;
                font-weight: lighter;
                color: rgba(255, 255, 255, 1);
            }

            .language {
                height: 33px;;
                line-height: 33px;
                font-size: 12px;
                font-family: STHeitiSC-Medium, STHeitiSC;
                font-weight: 500;
                color: rgba(255, 255, 255, 0.7);
            }

            .line {
                width: 1px;
                height: 17px;
                background: white;
                position: absolute;
                top: 50%;
                left: 32%;
                transform: translate(-50%, -50%);
            }
        }

        .second {
            margin-top: 26px;
            border-radius: 8px;
            background: #fff;
            padding: 15px 25px;
            border: 1px solid rgba(47, 159, 242, 0.1);
            box-shadow: 0px 2px 4px 0px rgba(47, 159, 242, 0.1);
        }

        .imgBox {
            width: 25%;
            padding: 4px;

            img {
                margin: 7px auto;
                width: 46px;
                height: 46px;
            }

            .text {
                text-align: center;
                // width:60px;
                margin: 0 auto;
                height: 12px;
                font-size: 12px;
                font-family: STHeitiSC-Light, STHeitiSC;
                font-weight: 300;
                color: rgba(46, 46, 46, 1);
                line-height: 12px;
            }
        }
    }

    .title-text {
        // width:56px;
        line-height: 40px;
        height: 40px;
        font-size: 14px;
        font-family: STHeitiSC-Medium, STHeitiSC;
        font-weight: bold;
        color: rgba(46, 46, 46, 1);
        line-height: 40px;
    }

    .third {
        margin-top: 150px;
        padding: 0 14px;

        .item-feature {
            box-shadow: 0px 2px 4px 0px rgba(47, 159, 242, 0.1);
            border-radius: 6px;
            border: 1px solid rgba(47, 159, 242, 0.1);
            padding: 4px 10px;

            .feature-img {
                width: 34px;
                height: 34px;
            }
            .flex-c{
                display: flex;
                flex-direction: column;
                justify-content: center;
            }
            .feature-text {
                margin-left: 10px;
                height: 34px;

                .text-first {
                    // width:56px;
                    height: 17px;
                    font-size: 14px;
                    font-family: STHeitiSC-Medium, STHeitiSC;
                    font-weight: 500;
                    color: rgba(46, 46, 46, 1);
                    line-height: 17px;
                }

                .text-second {
                    // margin-top:4px;
                    height: 17px;
                    font-size: 12px;
                    font-family: STHeitiSC-Medium, STHeitiSC;
                    font-weight: 500;
                    color: rgba(116, 116, 116, 1);
                    line-height: 17px
                }
            }
        }
    }

    .message-date {
        margin-top: 4px;
    }

    .swipe {
        border-top: 10px solid #f5f5f5;
        border-bottom: 10px solid #f5f5f5;
        padding: 10px 14px;
        width: 100%;
        margin-top: 20px;
        // border-radius: 8px;
        overflow: hidden;

        .swipe-img {
            height: 126px;
            width: 100%;
        }
    }

    .message-center {
        padding: 0 14px;
        padding-bottom: 70px;
        margin-top: 10px;

        .title-text {
            height: 40px;
            line-height: 40px;
        }

        .message-box {
            .message-item {
                border: 1px solid rgba(47, 159, 242, 0.1);
                background: #fff;
                padding: 10px;
                border-radius: 14px;
                box-shadow: 0px 2px 4px 0px rgba(47, 159, 242, 0.15);
                position: relative;

                .message-img {
                    width: 34px;
                    height: 34px;
                }

                .middle {
                    margin-left: 14px;
                    height: 34px;

                    .text-first {
                        width: 210px;
                        height: 17px;
                        font-size: 14px;
                        font-family: STHeitiSC-Light, STHeitiSC;
                        font-weight: 300;
                        color: #2E2E2E;
                        line-height: 17px;
                    }

                    .text-second {
                        height: 17px;
                        font-size: 12px;
                        font-family: STHeitiSC-Light, STHeitiSC;
                        font-weight: 300;
                        color: #747474;
                        line-height: 17px;
                    }
                }

                .arrowImg-box {
                    position: absolute;
                    top: 50%;
                    right: 10px;
                    transform: translate(-50%, -50%);

                    .arrowImg {
                        width: 11px;
                        height: 20px;
                    }
                }
            }
        }
    }
</style>
